import { withRouter } from "react-router-dom";

import Grid from "@mui/material/Grid";

import Portal from "../ui/portal";
import PortalAppBar from "../ui/portalAppBar";
import PortalGridContent from "../ui/portalGridContent";
import BotpressProducts from "../widgets/botpressProducts";
import BotpressSiteMap from "../widgets/botpressSiteMap";

const BotpressAdminPortal = props => {
  return (
    <Portal>
      <PortalAppBar title="Botpress Admin Portal" botpressStyle={true} />
      <PortalGridContent>
        <Grid size={{ xs: 12 }}>
          <BotpressProducts minHeight={"0px"} />
        </Grid>

        <Grid size={{ xs: 12 }}>
          <BotpressSiteMap minHeight={"0px"} />
        </Grid>
      </PortalGridContent>
    </Portal>
  );
};

export default withRouter(BotpressAdminPortal);
